<template>
    <div>
        <div class="dove">
            <span class="material-symbols-outlined f40">menu_book</span>
            <p class="mb-0">
                <b>
                    <inc-order-type :type="this.order.tipo_ordine"
                                    :translation="this.order.ordine_punto_di_servizio_traduzione_ll"/>
                </b>
            </p>
            <div class="f14">
                <inc-order-datetime :datetime-delivery-takeaway="this.order.data_ora_consegna_ritiro"
                                    :delivery-takeaway-end-slot="this.order.consegna_ritiro_fine_fascia"
                                    :language="language"/>
                <span v-if="this.order.n_persone">
                    - {{this.order.n_persone}} {{$tc('prenotazioni_tavolo.persona', this.order.n_persone)}}
                </span>
            </div>
            <div v-if="this.order.nome_tavolo">
                {{this.order.nome_tavolo}}
            </div>
            <div v-if="this.order.f_appena_possibile" class="f14 d-flex align-items-center justify-content-center">
                <span class="material-symbols-outlined">acute</span>
                {{$t('ordine_appena_possibile')}}
            </div>
            <div class="indirizzo mt-3">
                <span class="material-symbols-outlined f40">pin_drop</span>
                <!-- DELIVERY -->
                <div v-if="this.order.tipo_ordine === 'DIL' && this.order.id_punto_di_servizio">
                    <b>{{$t('punto_consegna')}}</b>
                    <div>
                        {{this.order.ordine_punto_di_servizio_traduzione_ll.nome}}
                    </div>
                    <div>
                        {{this.order.ordine_punto_di_servizio_traduzione_ll.label_delivery}}
                        {{this.order.punto_di_servizio_punto_consegna}}
                    </div>
                </div>
                <div v-else-if="this.order.tipo_ordine === 'DELIVERY'">
                    <b>{{$t('ordine_consegna_id')}}</b><br>
                    <div class="f14" v-html="this.order_delivery_address"></div>
                    <div class="f14" v-if="this.order.campanello">
                        <br>
                        {{$t('account.campanello')}}: {{this.order.campanello}}
                    </div>
                </div>
                <div v-else>
                    <!-- TAKE AWAY -->
                    <b>{{this.order.locale.nome_locale}}</b><br>
                    <div class="f14">
                      {{this.order.locale.indirizzo}}, {{this.order.locale.civico}} - {{this.order.locale.cap}} {{this.order.locale.citta}} ({{this.order.locale.provincia}}) - {{this.order.locale.stato}}
                    </div>
                </div>
            </div>
            <div v-if="this.order.tipo_racer === 'GLOVO' || this.order.tipo_racer === 'STUART'" class="indirizzo">
                <img v-if="this.order.tipo_racer === 'GLOVO'" height="30" src="/img/be/glovo-status.png">
                <img v-if="this.order.tipo_racer === 'STUART'" height="30" src="/img/be/stuart-status.png">
                <br>
                <div>
                    <span>{{getGlovoStatus(this.order.status_spedizione)}}</span>
                    <div v-if="order.nominativo_corriere_spedizione || order.telefono_corriere_spedizione">
                        <span>{{ getGlovoCourier(order.nominativo_corriere_spedizione, order.telefono_corriere_spedizione) }}</span>
                    </div>
                </div>
            </div>
            <div class="mt-5" v-if="this.show_pay_order_msg">
                <p><b>{{this.getSpecificTranslation('istruzioni')}}</b></p>
            </div>
        </div>
        <!-- PAGAMENTO -->
        <div class="titolo-sezioni-cart border-top">{{$t('carrello_mod_pagamento')}}:</div>
        <div class="blocchetto-selezioni py-2">
            <inc-order-payment-mode
                :payment-mode="this.order.modalita_pagamento"
                :payment-preference="this.order.preferenza_pagamento"
                :order-type="this.order.tipo_ordine"
            />
        </div>
        <!-- STATO PAGAMENTO -->
        <div v-if="this.order.modalita_pagamento !== 'CONTANTI'">
            <div class="titolo-sezioni-cart">{{$t('stato_pagamento')}}</div>
            <div class="blocchetto-selezioni py-2">
                <inc-order-payment-status :payment-status="this.order.status_pagamento"/>
            </div>
        </div>
        <!-- FATTURA -->
        <div v-if="this.order.fat_fatturazione_tipo" class="border-top">
            <div class="titolo-sezioni-cart">{{$t('ordine_fatturare_a')}}:</div>
            <div class="blocchetto-selezioni">
                <span v-if="this.order.fat_fatturazione_tipo === 'AZIENDA'">
                    {{this.order.fat_ragione_sociale}}
                    <br>
                    {{$t('piva')}}: {{this.order.fat_piva}} -
                </span>
                <span v-if="this.order.fat_cod_fisc">
                    {{$t('cod_fisc')}}: {{this.order.fat_cod_fisc}}
                </span>
                <br>
                {{this.order_billing_address}}
                <div v-if="this.order.fat_sdi && this.order.fat_pec">
                    <br/>
                    <span v-if="this.order.fat_sdi">
                        SDI: {{this.order.fat_sdi}} - PEC: {{this.order.fat_pec}}
                    </span>
                </div>
                <div v-else-if="this.order.fat_sdi">
                    SDI: {{this.order.fat_sdi}}
                </div>
                <div v-else-if="this.order.fat_pec">
                    PEC: {{this.order.fat_pec}}
                </div>
            </div>
        </div>
        <!-- NOTE -->
        <div v-if="this.order.note_cliente" class="border-top">
          <div class="titolo-sezioni-cart">{{$t('carrello_note_generali')}}</div>
          <div class="blocchetto-selezioni">{{this.order.note_cliente}}</div>
        </div>
        <!-- EXTRA -->
        <div v-if="this.order.extra.length" class="border-top">
            <div class="titolo-sezioni-cart">EXTRA</div>
            <div class="blocchetto-selezioni py-2">
                <div v-for="extra in this.order.extra">
                    {{extra.nome}}:
                    <span v-if="extra.tipo === 'LIBERO'">{{extra.valore}}</span>
                    <span v-if="extra.tipo === 'SCELTA'">{{extra.valore == 1 ? $t('si') : $t('no')}}</span>
                </div>
            </div>
        </div>
        <!-- RIEPILOGO CARRELLO -->
        <div class="titolo-sezioni-cart border-bottom border-top">{{$t('carrello_riepilogo')}}</div>

        <!-- prodotto -->
        <div v-for="row in this.order.righe">
            <div class="prodotto">
                <div class="d-flex align-items-center">
                    <div class="quantita">
                        {{row.qta}}
                    </div>
                    <div class="nome ml-3">{{row.nome_prodotto}} <img v-if="!row.f_sconto" src="/img/be/ico-nodiscount.png" width="20" class="ml-2" /> </div>
                    <div class="prezzo ml-auto">
                        {{row.totale_riga.toFixedGood(2)}} {{locale_currency}}
                    </div>
                </div>
            </div>
            <div class="opzioni">
                <div class="note d-flex align-items-start justify-content-start" v-if="row.note">
                    <span>{{$t('note')}}:</span> {{row.note}}
                </div>
                <div class="misura d-flex justify-content-between">
                    <div v-if="row.f_prodotto_composto">
                        <div v-if="row.prodotto_composto_tipo_prezzo === 'FISSO'">
                            {{$t('prezzo_fisso')}}
                        </div>
                        <div v-else>
                            {{$t('prezzo_minimo')}}
                        </div>
                    </div>
                    <div v-else>
                        {{$t('ordine.misura')}}: {{row.misura_nome}}
                    </div>
                    <span>{{row.misura_prezzo.toFixedGood(2)}} {{locale_currency}}</span>
                </div>
                <div class="misura" v-if="row.variante_nome">
                    {{$t('ordine.variante_titolo')}}: {{row.variante_nome}}
                    <span v-if="row.variante_prezzo">
                        {{((row.variante_prezzo < 0) ? " - " : " + ") + Math.abs(row.variante_prezzo).toFixedGood(2)}} {{locale_currency}}
                    </span>
                </div>
                <ul>
                    <li v-for="free_pick in getOrderRowFreePicks(row.scelte_libere)" class="d-flex align-items-center justify-content-between">
                        <div class="flex-grow-1 text-truncate">{{free_pick.name}} ({{$t("qta")}}: {{free_pick.quantity}})</div>
                        <span class="text-right" style="min-width: 80px;">
                            {{free_pick.price >= 0 ? " + " : " - "}}
                            {{(free_pick.price * free_pick.quantity).toFixedGood(2)}} {{locale_currency}}
                        </span>
                    </li>
                </ul>
                <ul>
                    <li v-for="addition in row.aggiunte" class="d-flex align-items-center justify-content-between">
                        <div class="flex-grow-1 text-truncate">{{addition.nome_ingrediente}}</div>
                        <span class="text-right" style="min-width: 80px;">
                            {{((addition.prezzo < 0) ? " - " : " + ") + Math.abs(addition.prezzo).toFixedGood(2)}} {{locale_currency}}
                        </span>
                    </li>
                </ul>
                <ul>
                    <li v-for="associated in row.prodotto_composto_contenuto" class="d-flex align-items-center justify-content-between">
                        <div class="flex-grow-1 text-truncate">{{associated.nome_prodotto}} ({{$t("qta")}}: {{associated.qta}})</div>
                        <span class="text-right" style="min-width: 80px;" v-if="associated.prezzo_prodotto">
                            {{associated.prezzo_prodotto >= 0 ? " + " : " - "}}
                            {{Math.abs(associated.prezzo_prodotto * associated.qta).toFixedGood(2)}} {{locale_currency}}
                        </span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="d-flex justify-content-between align-items-center" v-if="['DELIVERY', 'DIL'].includes(this.order.tipo_ordine)">
              <div class="titolo-sezioni-cart d-flex align-items-center">
                <span class="material-symbols-outlined mr-3">shopping_bag_speed</span>
                {{$t('ordine_consegna')}}
              </div>
              <div class="prezzo pr-3" v-if="this.order.spese_consegna">
                  {{this.order.spese_consegna.toFixedGood(2)}} {{locale_currency}}
              </div>
              <div class="prezzo pr-3" v-else>
                  {{$t('gratis')}}
              </div>
        </div>

        <div class="d-flex justify-content-between align-items-center" v-if="this.order.id_codice_sconto">
              <div class="titolo-sezioni-cart d-flex align-items-center">
                  <span class="material-symbols-outlined mr-3">percent_discount</span>
                  {{$t('sconto_applicato')}}: {{this.order.nome_codice_sconto}}
                  <span v-if="this.order.valore_codice_sconto">
                      <span v-if="this.order.tipo_codice_sconto === 'PERCENTUALE'">
                          ({{this.order.valore_codice_sconto}}%)
                      </span>
                      <span v-else>
                          ({{this.order.valore_codice_sconto}} {{locale_currency}})
                      </span>
                  </span>
              </div>
              <div class="prezzo pr-3">
                  <span v-if="this.order.f_spedizione_gratis_codice_sconto">
                      {{$t('coupon_spedizione_gratuita')}}
                  </span>
                  <span v-else>
                      {{(this.order.valore_sconto * -1).toFixedGood(2)}} {{locale_currency}}
                  </span>
              </div>
        </div>

        <div class="d-flex justify-content-between align-items-center" v-for="reward in this.order.fidelity_card_premi">
            <div class="titolo-sezioni-cart d-flex align-items-center">
                <span class="material-symbols-outlined mr-3">percent_discount</span>
                {{$t('premio_applicato')}}:
                <span v-if="reward.premio.tipo === 'VALORE'">
                    {{reward.premio.valore}} {{locale_currency}}
                </span>
                <span v-else-if="reward.premio.tipo === 'PERCENTUALE'">
                    {{reward.premio.valore}} %
                </span>
                <span v-else-if="reward.premio.tipo === 'PRODOTTO'">
                    {{reward.nome_tipologia_prodotto}} - {{reward.nome_prodotto}}
                </span>
            </div>
            <div class="prezzo pr-3">{{reward.valore.toFixedGood(2)}} {{locale_currency}}</div>
        </div>

        <div class="d-flex justify-content-between align-items-center" v-if="this.order.costo_fisso_valore">
            <div class="titolo-sezioni-cart d-flex align-items-center">
              <span class="material-symbols-outlined mr-3">money_bag</span>
                <span class="codice_sconto">
                    {{this.order.costo_fisso_nome}}
                    <span v-if="this.order.costo_fisso_tipo === 'PERCENTUALE'">
                        ({{this.order.costo_fisso_valore}} %)
                    </span>
                    <span v-if="this.order.n_persone">
                        &nbsp;(x{{this.order.n_persone}})
                    </span>
                </span>
                <div v-if="this.order.costo_fisso_descrizione">
                    {{this.order.costo_fisso_descrizione}}
                </div>
            </div>
            <div class="prezzo_sconto prezzo pr-3">
                {{this.order.valore_fisso.toFixedGood(2)}} {{locale_currency}}
            </div>
        </div>

        <div class="subtotale gray py-0 px-3 mt-3">
            <div class="tot d-flex justify-content-between my-2">
                <div>{{ $t('totale') }}</div>
                <div>{{this.order.totale_ordine.toFixedGood(2)}} {{locale_currency}}</div>
            </div>
        </div>
        <br>

    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import { getGlovoStatus, getGlovoCourier } from "../../../libraries/utils";

import IncOrderPaymentMode from './IncOrderPaymentMode';
import IncOrderDatetime from './IncOrderDatetime';
import IncOrderType from './IncOrderType';
import IncOrderPaymentStatus from "./IncOrderPaymentStatus";

export default {
    name: "IncOrderContent",
    components: {IncOrderPaymentStatus, IncOrderPaymentMode, IncOrderDatetime, IncOrderType},
    props: ['order'],
    computed: {
        order_delivery_address: function () {
            return this.order.indirizzo + ', ' + this.order.numero_civico + ' - ' +
                (
                    this.order.cap_zona ? this.order.cap_zona : (
                        this.order.cap_citta ? this.order.cap_citta : ''
                    )
                ) + ' ' + this.order.localita_citta +
                (this.order.localita_zona ? '<br>' + this.$t('zona') + ': ' + this.order.localita_zona : '') +
                (this.order.provincia ? (' (' + this.order.provincia + ')') : '');
        },
        order_billing_address: function () {
            return this.order.fat_indirizzo + ', ' + this.order.fat_numero_civico + ' - ' + this.order.fat_cap +
                ' ' + this.order.fat_localita + (
                    (this.order.fat_provincia) ? ' (' + this.order.fat_provincia + ')' : ''
                ) + (this.order.fat_stato ? ' ' + this.order.fat_stato : '');
        },
        show_pay_order_msg: function () {
            return this.order.tipo_ordine === 'ORDINA_TAVOLO' && this.order.modalita_pagamento === 'CONTANTI' && this.order.status === 'ATTESA';
        },
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            locale: state => state.locale
        }),
        ...mapGetters('restaurant', {
            locale_currency: 'localeCurrency',
            getSpecificTranslation: 'specificTranslation'
        })
    },
    methods: {
        getOrderRowFreePicks: function (free_picks) {
            let groups = [];
            free_picks.forEach((pick) => {
                const idx = groups.findIndex((group) => group.id === pick.id_ingrediente);
                if (idx >= 0) {
                    groups[idx].quantity += 1;
                } else {
                    groups.push({
                        id: pick.id_ingrediente,
                        name: pick.nome_ingrediente,
                        price: pick.prezzo,
                        quantity: 1
                    })
                }
            });

            return groups;
        },
        getGlovoStatus,
        getGlovoCourier
    }
}
</script>
